import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    width: '100%',
    paddingTop: theme.spacing(1),
  },
  currency: {
    color: theme.palette.labraText.description,
    lineHeight: '20px',
    fontSize: '14px',
  },
  amount: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'flex-start',
  },
  headerNowrap: {
    whiteSpace: 'nowrap',
  },
}))
